import { CellProps } from 'react-table'
import { CargoActionsCell } from './CargoActionsCell'
import { CargoAsoList } from '../../core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useListView } from '../../core/ListViewProvider'
import {
  PlainHeader,
  SelectionCell,
  SelectionHeader,
  sortableColumn,
  StackedCell,
  TableColumn,
} from '../../../../../../components'
import { formatDateTime } from '../../../../../../../_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'

/** LocalDateTime do backend → "dd/mm/aaaa hh:mm"; ausente vira o traço do StackedCell. */
const dataHora = (date?: string) => (date ? formatDateTime(date) : undefined)

export const cargoColumns = (t: TFunction): ReadonlyArray<TableColumn<CargoAsoList>> => [
  {
    Header: (props) => (
      <SelectionHeader
        useListView={useListView}
        tableProps={props}
        ariaLabel='Selecionar todos desta página'
      />
    ),
    id: 'selection',
    cellWidth: '48px',
    Cell: ({ row }: CellProps<CargoAsoList>) => (
      <SelectionCell
        useListView={useListView}
        id={row.original.id}
        ariaLabel={`Selecionar ${row.original.nome ?? ''}`}
      />
    ),
  },
  // Código é a linha de apoio do nome; os dois seguem ordenáveis.
  sortableColumn<CargoAsoList>({
    id: 'nome',
    useQueryRequest,
    fields: [
      { field: 'nome', label: 'Cargo' },
      { field: 'codigo', label: t('cols.codigo') },
    ],
    Cell: ({ row }: CellProps<CargoAsoList>) => (
      <StackedCell primary={row.original.nome} secondary={row.original.codigo} />
    ),
  }),
  // Última edição em destaque; criação como linha de apoio.
  {
    Header: () => (
      <PlainHeader>
        {t('cols.data.edicao')} / {t('cols.data.criacao')}
      </PlainHeader>
    ),
    id: 'dataAlteracao',
    cellWidth: '188px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<CargoAsoList>) => (
      <StackedCell
        tabular
        primary={dataHora(row.original.dataAlteracao)}
        secondary={dataHora(row.original.dataInclusao)}
      />
    ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<CargoAsoList>) => <CargoActionsCell cargo={row.original} />,
  },
]
